module.exports = __webpack_public_path__ + "img/firebase.b2797802.png";